// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"30":"b9b2a822","372":"eea33de4","744":"98e70514","945":"578d9a90","960":"17c77bd7"}[chunkId] + ".css";
};